<div class="gauge" [class.pool]="pool" #gauge>
  <div class="value">
    <div>
      {{ value ? value.toFixed(2) : '--' }}
    </div>
  </div>
</div>
